<template>
<div id="preprint-list">
    <h1 v-if="preprints.length > 0">Pre-print</h1>
    <div class="preprint-container">
        <el-timeline>
            <div v-for="(i, index) in preprints" :key="i.id">
                <PublicationItem :item="i" :index="index" :itemStatus="itemStatus" :switchStatus="switchStatus"/>
            </div>
        </el-timeline>
    </div>
</div>
</template>

<script>
import PublicationItem from './PublicationItem.vue'

export default {
    name: 'PreprintList',
    components: { PublicationItem },
    data() {
        return {
            itemStatus: [],
            preprints: [
                {
                    id: "gao2025treat",
                    name: "TREAT: A Code LLMs Trustworthiness / Reliability Evaluation and Testing Framework",
                    authors: ["Shuzheng Gao", "Eric John Li", "Man Ho Lam", "Jingyu Xiao", "Yuxuan WAN", "Chaozheng Wang", "Ng Man Tik", "Michael R. Lyu"],
                    figname: "gao2025treat.png",
                    conference: "arXiv:2510.17163",
                    paper: "arXiv",
                    websiteLink: "https://code-treat-web.vercel.app",
                    paperLink: "https://arxiv.org/abs/2510.17163",
                },
                {
                    id: "li2025jsprotect",
                    name: "JSProtect: A Scalable Obfuscation Framework for Mini-Games in WeChat",
                    authors: ["Zhihao Li", "Chaozheng Wang", "Zongjie Li", "Xinyong Peng", "Zelin Su", "Qun Xia", "Haochuan Lu", "Ting Xiong", "Man Ho Lam", "Shuzheng Gao", "Yuchong Xie", "Cuiyun Gao", "Shuai Wang", "Yuetang Deng", "Huafeng Ma"],
                    figname: "li2025jsprotect.png",
                    conference: "arXiv:2509.24498",
                    paper: "arXiv",
                    paperLink: "https://arxiv.org/abs/2509.24498",
                },
                {
                    id: "zhou2025pimmur",
                    name: "The PIMMUR Principles: Ensuring Validity in Collective Behavior of LLM Societies",
                    authors: ["Jiaxu Zhou", "Jen-tse Huang", "Xuhui Zhou", "Man Ho Lam", "Xintao Wang", "Hao Zhu", "Wenxuan Wang", "Maarten Sap"],
                    figname: "zhou2025pimmur.png",
                    conference: "arXiv:2509.18052",
                    paper: "arXiv",
                    paperLink: "https://arxiv.org/abs/2509.18052",
                },
                {
                    id: "xiao2025designbench",
                    name: "DesignBench: A Comprehensive Benchmark for MLLM-based Front-end Code Generation",
                    authors: ["Jingyu Xiao", "Ming Wang", "Man Ho Lam", "Yuxuan Wan", "Junliang Liu", "Yintong Huo", "Michael R. Lyu"],
                    figname: "xiao2025designbench.png",
                    conference: "arXiv: 2506.06251",
                    paper: "arXiv",
                    websiteLink: "https://webpai.github.io/DesignBench/",
                    paperLink: "https://arxiv.org/abs/2506.06251",
                    codeLink: "https://github.com/WebPAI/DesignBench",
                },
            ]
        }
    },
    methods: {
        switchStatus(index){
            let status = this.itemStatus[index] === '' ? 'collapsed' : ''
            this.itemStatus.forEach((e, i) => {
                if(index === i){
                    this.itemStatus.splice(i, 1, status)
                }else{
                    this.itemStatus.splice(i, 1, 'collapsed')
                }
            })
        }
    },
    mounted() {
        for(let i = 0; i < this.items.length; i++){
            this.itemStatus.push('collapsed')
        }
    },
}
</script>

<style scoped>
#preprint-list{
    width: 1000px;
    min-width: 1000px;
    margin: 50px auto;
}
h1{
    font-size: 30px;
    line-height: 1.0;
    margin-bottom: 50px;
    text-align: left;
    color: #111111;
    font-family: "Comic Sans MS", "Comic Sans", "cursive";
    font-weight: bolder;
}
.publication-container, .preprint-container{
    width: 1000px;
    margin: auto;
}
a {
    text-decoration: none;
    color: #3670C9;
    cursor: pointer;
}

a:hover {
    color: #FF5733;
}

</style>